import React, { FC } from "react";
import type { SolutionsItemProps } from "@/types";
import { NextPage } from "../next-page";
import { Image } from "../image";
import { TextCols } from "../text-cols";

export const SolutionsItem: FC<SolutionsItemProps> = ({
  cols,
  cover,
  nextPage,
}) => {
  return (
    <section className="solutionsItem">
      <div className="solutionsItem--inner">
        <div className="wrapper">
          <TextCols
            content={{
              title: cols.title,
              textCol1: cols.textCol1,
              textCol2: cols.textCol2,
            }}
          />
        </div>
        <div className="wrapper wrapper_lg">
          {cover.file?.url && (
            <Image
              className="solutionsItem--cover"
              src={cover as any}
              alt={cover.title}
              animateInView
            />
          )}
        </div>
        <div className="wrapper">
          <NextPage {...nextPage} />
        </div>
      </div>
    </section>
  );
};
